// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_html2canvas_dist_html2canvas_js":"a4d3d2bdff5a899d","node_modules_dompurify_dist_purify_js":"0ec6c93b666a6772","node_modules_canvg_lib_index_es_js":"19dabd3a10043dd4"}[chunkId] + ".js";
};